<template>
  <div class="wrapper-content w-100">
    <div id="printContainer">
      <div class="detalle_remito">
        <img :src="collapsedLogoImg" alt="" height="46" class="float-right mr-2 logoImg">
        <h2 v-if="customListTitle">{{ customListTitle }}</h2>
        <h2 v-else>{{ title }}</h2>
        <LmBreadcrumb v-if="showBreadcrumb" />
        <h4 v-for="(subTitle, index) in customListSubTitles" :key="index">{{ subTitle }}</h4>
        <LmTableCustom
          :key="componentKey"
          :order = order
          :orderBySetting = orderBySetting
          :searchOnFields = searchOnFields
          :perPageSetting = perPageSetting
          :itemsPerPage = defaultItemsPerPage
          :limitExportFromClient = limitExportFromClient
          :apiCallPath = apiCallPath
          :highlight = highlight
          :showFilterTime = showFilterTime
          :showGoBackButton = showGoBackButton
          :showPDFButton = showPDFButton
          :showCSVButton = showCSVButton
          :hideSearchSection = hideSearchSection
          :downloadCsvFileName = downloadCsvFileName
          :lmListActions = lmListActions
          :enablePreloadFiltering = enablePreloadFiltering
          />
      </div>
    </div>
    <LmForm>
      <LmButton
        v-if="this.tableItems.length"
        type="button"
        @click.native="print()"
        :value="$t('print')"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        />
      <LmButton
        v-if="this.tableItems.length"
        type="submit"
        buttonClass="btn-danger"
        :isProcessing="formIsProcessing"
        value="Confirmar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        :disabled="isSendButtonDisabled"
        @click.native="submit"
        />
      <LmButton
        v-if="enableGoBackButton"
        type="button"
        buttonClass="btn-secondary"
        :value="$t('go_back')"
        @click.native="goBackBtn"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        />
      <LmButton
        v-if="!enableGoBackButton"
        type="button"
        buttonClass="btn-secondary"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
        />
    </LmForm>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LmForm from '@/components/form/LmForm.vue'
import LmTableCustom from '@/components/LmTableCustom'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'

export default {
  mixins: [lmSuperPowerSelectHelper],
  components: {
    LmForm,
    LmButton,
    LmTableCustom,
    LmDateTime,
    LmDate,
    LmSuperPowerSelect
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      formIsProcessing: false,
      // table
      componentKey: 0,
      hideSearchSection: true,
      order: ['desc', 'asc'],
      orderBySetting: ['fecha_emision'],
      searchOnFields: [],
      perPageSetting: [5, 10, 15, 20, 50],
      defaultItemsPerPage: 800,
      limitExportFromClient: 10000,
      showFilterTime: true,
      apiCallPath: `remitos/detailtoconfirm/`,
      showCSVButton: false,
      showGoBackButton: false,
      showPDFButton: false,
      downloadCsvFileName: 'remitos',
      lmListActions: [],
      highlight: {},
      enablePreloadFiltering: true
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail', 'tableItems', 'customListTitle', 'customListSubTitles']),
    ...mapState('settings', ['collapsedLogoImg']),
    isSendButtonDisabled () {
      return this.tableItems.length === 0 || this.tableItems.filter(i => i.lmChecked).length === 0
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    ...mapActions('session', ['getUserInfo']),
    goBackBtn () {
      this.$router.go(-1)
    },
    cancelBtn () {
      this.$router.go(-1)
    },
    print () {
      const prevTitle = document.title
      document.title = `remito-${this.$route.params.id}`
      this.$htmlToPaper('printContainer')
      document.title = prevTitle
    },
    async submit () {
      try {
        this.formIsProcessing = true
        /**
         * Se persisten los datos
         */
        let saveData = {
          id: this.$route.params.id,
          transacciones: this.tableItems.filter(i => i.lmChecked).map(i => i.hidden_ntransac)
        }
        try {
          await this.updateItemDetail({
            path: 'remitos/confirm/',
            data: saveData
          })
          this.formIsProcessing = false
          this.$router.push(this.onSuccessDestinationRoute)
        } catch (error) {
          this.formIsProcessing = false
          if (error.response && error.response.status === 400) {
            this.$bvToast.toast(error.response.data.message, {
              title: 'Error',
              toaster: 'b-toaster-bottom-center',
              variant: 'danger',
              solid: true
            })
          } else {
            this.$bvToast.toast(this.$t('try_again_later'), {
              title: 'Error',
              toaster: 'b-toaster-bottom-center',
              variant: 'danger',
              solid: true
            })
          }
        }
      } catch (error) {
        console.log('error', error)
      }
    }
  }
}
</script>
<style lang="sass" scoped>
  .logoImg
    display: none
</style>
